import { render, staticRenderFns } from "./radioField.vue?vue&type=template&id=554412d8&scoped=true&lang=pug&"
import script from "./radioField.vue?vue&type=script&setup=true&lang=js&"
export * from "./radioField.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./radioField.vue?vue&type=style&index=0&id=554412d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554412d8",
  null
  
)

export default component.exports